import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';
import { batchRequest } from '../../api/ApiService';
import Auth from '../../routes/Auth';

import { Loader } from 'react-loaders';

import Navigation from './components/navigation';
import Pagination from './components/pagination';

import ResultsAreInStep1 from './pages/results-are-in/step1';
import ResultsAreInStep2 from './pages/results-are-in/step2';
import ResultsAreInStep5 from './pages/results-are-in/step5';
import ResultsAreInStep6 from './pages/results-are-in/step6';

import FeedbackOverall from './pages/feedback';

import MarketShareStep2 from './pages/feedback/market-share/step2';
import MarketShareStep3 from './pages/feedback/market-share/step3';
import MarketShareStep4 from './pages/feedback/market-share/step4';
import MarketShareStep5 from './pages/feedback/market-share/step5';
import MarketShareStep7 from './pages/feedback/market-share/step7';
import MarketShareStep8 from './pages/feedback/market-share/step8';
import MarketShareStep10 from './pages/feedback/market-share/step10';
import MarketShareStep11 from './pages/feedback/market-share/step11';
import MarketShareStep13 from './pages/feedback/market-share/step13';
import MarketShareStep14 from './pages/feedback/market-share/step14';
import MarketShareStep18 from './pages/feedback/market-share/step18';
import MarketShareStep19 from './pages/feedback/market-share/step19';
import MarketShareStep20 from './pages/feedback/market-share/step20';
import MarketShareStep22 from './pages/feedback/market-share/step22';
import MarketShareStep23 from './pages/feedback/market-share/step23';

import RevenuesStep2 from './pages/feedback/revenues/step2';
import RevenuesStep3 from './pages/feedback/revenues/step3';
import RevenuesStep4 from './pages/feedback/revenues/step4';

import GrossMarginsStep2 from './pages/feedback/gross-margins/step2';
import GrossMarginsStep3 from './pages/feedback/gross-margins/step3';
import GrossMarginsStep5 from './pages/feedback/gross-margins/step5';
import GrossMarginsStep6 from './pages/feedback/gross-margins/step6';

import SharePriceStep2 from './pages/feedback/share-price/step2';
import SharePriceStep3 from './pages/feedback/share-price/step3';

import NetLossStep1 from './pages/feedback/net-loss/step1';
import NetLossStep2 from './pages/feedback/net-loss/step2';

import RoeStep2 from './pages/feedback/roe/step2';
import RoeStep3 from './pages/feedback/roe/step3';

import RoaStep2 from './pages/feedback/roa/step2';
import RoaStep3 from './pages/feedback/roa/step3';

import EpsStep2 from './pages/feedback/eps/step2';
import EpsStep3 from './pages/feedback/eps/step3';


import ResearchAndInvestigateStep1 from './pages/research-and-investigate/step1';
import GoodLuckStep1 from './pages/good-luck/step1';
import IconLock from "../../containers/assets/icon-lock.svg";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  background: #f5f6f7;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 80%;
  max-width: 794px;
  background: #f5f6f7;
`;

const RoundLockedScreen = {};
RoundLockedScreen.Wrapper = styled.div`
  height: 550px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  margin: 24px 50px;
  width: calc(100% - 100px);
  font-family: Lato;
  line-height: 100%;
`;
RoundLockedScreen.Image = styled.img`
  margin-bottom: 24px;
  width: 27px;
`;
RoundLockedScreen.Title = styled.h2`
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 32px;
`;
RoundLockedScreen.Text = styled.h3`
  font-size: 18px;
`;

class PerformanceFeedback extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: 0,
      currentStep: 0,
      navigation: [],
      reportsPerformanceFeedback: [],
      resultsTeamGrading: {},
      resultsTargets: {},
      loaded: false,
      visitsHistory: []
    };
  }

  componentDidMount() {
    const { rounds, location } = this.props;
    // Read round from URL directly instead of relying on activeRound
    // (which falls back to currentRound via a prop populated async by
    // App.js). On a fresh navigation to /performance-feedback?round=N
    // the roundInUrl prop can be stale for one tick, causing the check
    // below to fall back to the LIVE currentRound and incorrectly
    // redirect to /onboarding when the student is legitimately trying
    // to view a prior finished round's feedback.
    let urlRound = null;
    if (location && location.query && location.query.round) {
      const parsed = parseInt(location.query.round, 10);
      if (!isNaN(parsed)) urlRound = parsed;
    }
    const activeRound = urlRound != null ? urlRound : this.activeRound;
    const round = rounds.find(i => Number(i.number) === Number(activeRound));
    const isRoundLive = round ? (
      round.is_started === true
      && round.is_finished === false
      && round.should_be_finished === false
    ) : false;

    if (isRoundLive) {
      changeLocation(`/onboarding`);
    } else {
      this.loadNavigation(() => {
        this.updateCurrentState();
      });
    }
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return roundInUrl || currentRound;
  }

  loadNavigation(callback) {
    const activeRound = this.activeRound;

    batchRequest([
      `${process.env.REACT_APP_API_URL}v2/reports/performancefeedbacks/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/grading/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}v2/games/targets/?round_number=${activeRound}&course=${Auth.getCourseId()}`,
      `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}`,
    ]).then(res => {
      const results = res[0].body.results || [];
      const resultsTeamGrading = res[1].body[0] || {};
      const resultsTargets = res[2].body[0] || {};
      const priceForecasts = res[3].body || [];
      const inventoryBalances = res[4].body || [];

      const didNotSubmit = results.find(i => i.type.toLowerCase() === 'did not submit');

      const totalForecastsPrice = priceForecasts.reduce((sum, item) => sum + item.price, 0);
      const totalAvailableForSale = inventoryBalances.reduce((sum, item) => sum + item.available_for_sale, 0);
      const showDecisionsNotSubmitted = !!didNotSubmit && !totalForecastsPrice && !totalAvailableForSale;

      const insufficientCapital = results.find(i => i.type.toLowerCase() === 'insufficient capital');
      const showInsufficientCapital = !!insufficientCapital && !showDecisionsNotSubmitted;

      const foundMarketShareError1 = results.find(i => i.type.toLowerCase() === 'extended release date');
      const foundMarketShareError2 = results.find(i => i.type.toLowerCase() === 'minimum requirement failed');
      const foundMarketShareError3 = results.find(i => i.type.toLowerCase() === 'product market fit');
      const foundMarketShareError4 = results.find(i => i.type.toLowerCase() === 'awareness');
      const foundMarketShareError5 = results.find(i => i.type.toLowerCase() === 'place');
      const foundMarketShareError6 = results.filter(i => i.type.toLowerCase() === 'mobile overproduced' || i.type.toLowerCase() === 'auto overproduced');
      const foundMarketShareError7 = results.find(i => i.type.toLowerCase() === 'low inventory');
      const foundMarketShareError8 = results.find(i => i.type.toLowerCase() === 'low product ranking');

      const priceRangeFailed = results.find(i => i.type === "Price range failed");
      const showMarketShareStep2 = priceRangeFailed && !(didNotSubmit || insufficientCapital);

      const showMarketShareError1 = !!foundMarketShareError1;
      const showMarketShareError2 = !!foundMarketShareError2;
      const showMarketShareError3 = !!foundMarketShareError3;
      const showMarketShareError4 = !!foundMarketShareError4;
      const showMarketShareError5 = !!foundMarketShareError5;
      const showMarketShareError6 = foundMarketShareError6.length > 0;
      const showMarketShareError7 = !!foundMarketShareError7;
      const showMarketShareError8 = !!foundMarketShareError8;
      let showMarketShare = false;
      if (resultsTargets.market_share > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showMarketShare = true;
        }
      }

      const foundRevenuesError = results.find(i => i.type.toLowerCase() === 'expected revenue low');
      const showRevenuesError = !!foundRevenuesError;
      let showRevenues = false;
      if (resultsTargets.net_revenues > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showRevenues = true;
        }
      }

      const foundGrossMarginError1 = results.find(i => i.type.toLowerCase() === 'gross margin fail');
      const foundGrossMarginError2 = results.find(i => i.type.toLowerCase() === 'negative gross margins');
      const showGrossMarginError1 = !!foundGrossMarginError1 && !foundGrossMarginError2;
      const showGrossMarginError2 = !!foundGrossMarginError2;
      let showGrossMargin = false;
      if (resultsTargets.gross_margin > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showGrossMargin = true;
        }
      }

      const foundSharePriceError = results.find(i => i.type.toLowerCase() === 'share price fail');
      const showSharePriceError = !!foundSharePriceError;
      let showSharePrice = false;
      if (resultsTargets.stock_price > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2) {
          showSharePrice = true;
        }
      }

      const foundNetLossError = results.find(i => i.type.toLowerCase() === 'negative profits');
      const showNetLossError = !!foundNetLossError;
      let showNetLoss = false;
      if (showNetLossError && (resultsTargets.roe > 0 || resultsTargets.roa > 0 || resultsTargets.earnings_per_share > 0)) {
        const found1 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found2 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        const found3 = results.find(i => i.type.toLowerCase() === 'negative profits');
        if (!found1 && !found2 && found3) {
          showNetLoss = true;
        }
      }

      const foundROEError = results.find(i => i.type.toLowerCase() === 'roe fail');
      const showROEError = !!foundROEError;
      let showROE = false;
      if (!showNetLoss && resultsTargets.roe > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'negative profits');
        const found2 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found3 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2 && !found3) {
          showROE = true;
        }
      }

      const foundROAError = results.find(i => i.type.toLowerCase() === 'roa fail');
      const showROAError = !!foundROAError;
      let showROA = false;
      if (!showNetLoss && resultsTargets.roa > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'negative profits');
        const found2 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found3 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2 && !found3) {
          showROA = true;
        }
      }

      let showEPSError = false;
      const found = results.find(i => i.type.toLowerCase() === 'eps fail');
      if (found) {
        showEPSError = true;
      }

      let showEPS = false;
      if (!showNetLoss && resultsTargets.earnings_per_share > 0) {
        const found1 = results.find(i => i.type.toLowerCase() === 'negative profits');
        const found2 = results.find(i => i.type.toLowerCase() === 'did not submit');
        const found3 = results.find(i => i.type.toLowerCase() === 'not accepted decision that will be deleted');
        if (!found1 && !found2 && !found3) {
          showEPS = true;
        }
      }

      const navigation = [
        {
          title: 'Results Are In!',
          pattern: '/performance-feedback/results-are-in',
          steps: [
            ...(showInsufficientCapital ? [
              {
                url: '/performance-feedback/results-are-in/insufficient-capital',
                component: ResultsAreInStep1,
              },
            ] : []),
            ...(showDecisionsNotSubmitted ? [
              {
                url: '/performance-feedback/results-are-in/decisions-not-submitted',
                component: ResultsAreInStep2,
              },
            ] : []),
            {
              url: '/performance-feedback/results-are-in/round-team-score',
              component: ResultsAreInStep5,
            },
            {
              url: '/performance-feedback/results-are-in/financial-goals',
              component: ResultsAreInStep6,
            },
          ],
        },
        {
          title: 'Feedback',
          pattern: '/performance-feedback/feedback',
          steps: [
            {
              url: '/performance-feedback/overall',
              component: FeedbackOverall
            }
          ],
        },
        ...(showMarketShare ? [
          {
            parent: 'Feedback',
            title: 'Market Share',
            pattern: '/performance-feedback/market-share',
            steps: [
              ...(showMarketShareStep2 ? [
                {
                  url: '/performance-feedback/market-share/outside-price-range',
                  component: MarketShareStep2,
                }
              ] : []),
              ...(showMarketShareError1 ? [
                {
                  url: '/performance-feedback/market-share/release-date',
                  component: MarketShareStep3,
                  hasErrorAlert: true,
                },
              ] : []),
              ...(showMarketShareError2 ? [
                {
                  url: '/performance-feedback/market-share/demand-issue-no-customer',
                  component: MarketShareStep4,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/understand-the-customer',
                  component: MarketShareStep5,
                },
              ] : []),
              ...(showMarketShareError3 ? [
                {
                  url: '/performance-feedback/market-share/demand-issue-small-market',
                  component: MarketShareStep7,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/product-market-fit',
                  component: MarketShareStep8,
                },
              ] : []),
              ...(showMarketShareError4 ? [
                {
                  url: '/performance-feedback/market-share/demand-issue-low-visibility',
                  component: MarketShareStep10,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/awareness-matters',
                  component: MarketShareStep11,
                },
              ] : []),
              ...(showMarketShareError5 && false ? [ // channels-flow disabled per product; keep components wired for future re-enable
                {
                  url: '/performance-feedback/market-share/channels',
                  component: MarketShareStep13,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/place',
                  component: MarketShareStep14,
                },
              ] : []),
              ...(showMarketShareError6 ? [
                {
                  url: '/performance-feedback/market-share/overproduced',
                  component: MarketShareStep18,
                  hasErrorAlert: true,
                  performanceFeedbackData: foundMarketShareError6
                },
              ] : []),
              ...(showMarketShareError7 ? [
                {
                  url: '/performance-feedback/market-share/supply-issue',
                  component: MarketShareStep19,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/capacity-constraint',
                  component: MarketShareStep20,
                },
              ] : []),
              ...(showMarketShareError8 || false ? [ // hide this page for now since the backend needs to be adjusted
                {
                  url: '/performance-feedback/market-share/low-ranging-product',
                  component: MarketShareStep22,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/market-share/low-ranging-product-research-investigate',
                  component: MarketShareStep23,
                  hasErrorAlert: true,
                },
              ] : []),
            ],
          },
        ] : []),
        ...(showRevenues && showRevenuesError ? [
          {
            parent: 'Feedback',
            pattern: '/performance-feedback/revenues',
            title: 'Revenues',
            steps: [
              {
                url: '/performance-feedback/revenues/low-price',
                component: RevenuesStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/revenues/pricing-your-products',
                component: RevenuesStep3,
              },
              {
                url: '/performance-feedback/revenues/build-inventory',
                component: RevenuesStep4,
              },
            ],
          },
        ] : []),
        ...(showGrossMargin && (showGrossMarginError1 || showGrossMarginError2) ? [
          {
            parent: 'Feedback',
            title: 'Gross Margins',
            pattern: '/performance-feedback/gross-margins',
            steps: [
              ...(showGrossMarginError1 ? [
                {
                  url: '/performance-feedback/gross-margins/low-price-formula',
                  component: GrossMarginsStep2,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/gross-margins/low-price-unit-economics',
                  component: GrossMarginsStep3,
                },
              ] : []),
              ...(showGrossMarginError2 ? [
                {
                  url: '/performance-feedback/gross-margins/non-profit-formula',
                  component: GrossMarginsStep5,
                  hasErrorAlert: true,
                },
                {
                  url: '/performance-feedback/gross-margins/non-profit-unit-economics',
                  component: GrossMarginsStep6,
                },
              ] : []),
            ],
          },
        ] : []),
        ...(showSharePrice && showSharePriceError ? [
          {
            parent: 'Feedback',
            title: 'Share Price',
            pattern: '/performance-feedback/share-price',
            steps: [
              {
                url: '/performance-feedback/share-price/formula',
                component: SharePriceStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/share-price/excess-share-issuance',
                component: SharePriceStep3,
              },
            ],
          },
        ] : []),
        ...(showNetLoss ? [
          {
            parent: 'Feedback',
            title: 'Net Loss',
            pattern: '/performance-feedback/net-loss',
            steps: [
              {
                url: '/performance-feedback/net-loss/stats',
                component: NetLossStep1,
              },
              ...(showNetLossError ? [
                {
                  url: '/performance-feedback/net-loss/profit',
                  component: NetLossStep2,
                  hasErrorAlert: true,
                },
              ] : []),
            ],
          },
        ] : []),
        ...(showROE && showROEError ? [
          {
            parent: 'Feedback',
            title: 'Return on Equity',
            pattern: '/performance-feedback/roe',
            steps: [
              {
                url: '/performance-feedback/roe/formula',
                component: RoeStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/roe/return-on-investments',
                component: RoeStep3,
              },
            ],
          },
        ] : []),
        ...(showROA && showROAError ? [
          {
            parent: 'Feedback',
            title: 'Return on Assets',
            pattern: '/performance-feedback/roa',
            steps: [
              {
                url: '/performance-feedback/roa/formula',
                component: RoaStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/roa/return-on-investments',
                component: RoaStep3,
              },
            ],
          },
        ] : []),
        ...(showEPS && showEPSError ? [
          {
            parent: 'Feedback',
            title: 'Earnings Per Share',
            pattern: '/performance-feedback/eps',
            steps: [
              {
                url: '/performance-feedback/eps/formula',
                component: EpsStep2,
                hasErrorAlert: true,
              },
              {
                url: '/performance-feedback/eps/return-on-investments',
                component: EpsStep3,
                hasErrorAlert: true,
              },
            ],
          },
        ] : []),
        {
          title: 'Research & Investigate',
          pattern: '/performance-feedback/research-and-investigate',
          steps: [
            {
              url: '/performance-feedback/research-and-investigate',
              component: ResearchAndInvestigateStep1,
            },
          ],
        },
        {
          title: 'Good Luck!',
          pattern: '/performance-feedback/good-luck',
          steps: [
            {
              url: '/performance-feedback/good-luck',
              component: GoodLuckStep1,
            },
          ],
        },
      ];

      if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
        this.setState({
          navigation,
          reportsPerformanceFeedback: results,
          resultsTeamGrading,
          resultsTargets,
          loaded: true,
        }, () => {
          if (callback) {
            callback();
          }
        });
      } else {
        if (callback) {
          callback();
        }
      }
    })
      .catch(err => { });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateCurrentState();
    }
  }

  updateCurrentState = () => {
    const { navigation } = this.state;

    let currentCategory = 0;
    let currentStep = 0;
    for (let i = 0; i < navigation.length; i++) {
      const stepIndex = navigation[i].steps.findIndex(j => j.url === this.props.location.pathname);
      if (stepIndex > -1) {
        currentCategory = i;
        currentStep = stepIndex;
        break;
      }
    }

    if (
      currentCategory !== this.state.currentCategory
      || currentStep !== this.state.currentStep
    ) {

      this.setState({
        currentCategory,
        currentStep,
      }, () => {
        this.checkLocation();
      });
    } else {
      if (this.props.location.pathname === '/performance-feedback') {
        this.checkLocation();
      }
    }
  }

  checkLocation = () => {
    const { currentCategory, currentStep, navigation } = this.state;
    const activeRound = this.activeRound;

    const roundInPath = this.props.location.query.round;
    let roundChange = false;
    if (roundInPath && Number(roundInPath) !== Number(activeRound)) {
      roundChange = true;
    }

    if (this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url && !roundChange) {
      changeLocation(`${navigation[currentCategory].steps[currentStep].url}?round=${activeRound}`);
    }
  }

  goNext = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let nextCategory = currentCategory;
    let nextStep = currentStep + 1;
    if (nextStep >= navigation[currentCategory].steps.length) {
      nextCategory = currentCategory + 1;
      nextStep = 0;

      if (nextCategory >= navigation.length) {
        return false;
      } else if (nextStep >= navigation[nextCategory].steps.length) {
        nextCategory = currentCategory + 2;
        nextStep = 0;

        if (nextCategory >= navigation.length) {
          return false;
        }
      }
    }

    this.setState({
      currentCategory: nextCategory,
      currentStep: nextStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  goPrev = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let prevCategory = currentCategory;
    let prevStep = currentStep - 1;
    if (prevStep < 0) {
      prevCategory = currentCategory - 1;
      if (prevCategory < 0) {
        return false;
      }

      prevStep = navigation[prevCategory].steps.length - 1;
      if (prevStep < 0) {
        prevCategory = currentCategory - 2;
        if (prevCategory < 0) {
          return false;
        }

        prevStep = navigation[prevCategory].steps.length - 1;
      }
    }

    this.setState({
      currentCategory: prevCategory,
      currentStep: prevStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  get isFirstStep() {
    const { currentCategory, currentStep } = this.state;

    return currentCategory === 0 && currentStep === 0;
  }

  get isLastStep() {
    const { currentCategory, currentStep, navigation } = this.state;

    const lastCategory = navigation.length - 1;
    const lastStep = navigation[lastCategory].steps.length - 1;

    return currentCategory === lastCategory && currentStep === lastStep;
  }

  get countOfSteps() {
    const { currentCategory, navigation } = this.state;

    return navigation[currentCategory].steps.length;
  }

  render() {
    const {
      currentCategory,
      currentStep,
      navigation,
      loaded,
      visitsHistory,
      reportsPerformanceFeedback,
      resultsTeamGrading,
      resultsTargets
    } = this.state;
    const { rounds } = this.props;
    const activeRound = this.activeRound;
    const currentRound = rounds.find(i => Number(i.number) === Number(activeRound));

    if (navigation.length === 0 || !loaded) {
      return (
        <Wrapper>
          <Loader type="ball-scale-ripple" active />
        </Wrapper>
      );
    }

    const category = navigation[currentCategory];
    let Component = null;
    let previousShownErrors = 0;
    let performanceFeedbackData = null;
    if (category) {
      Component = category.steps[currentStep].component;

      const url = category.steps[currentStep].url;
      const allSteps = navigation.reduce((prev, curr) => ([
        ...prev,
        ...curr.steps,
      ]), []);

      const currentStepIndex = allSteps.findIndex(i => i.url === url);
      previousShownErrors = allSteps.slice(0, currentStepIndex).filter(i => i.hasErrorAlert === true).length;
      performanceFeedbackData = category.steps[currentStep].performanceFeedbackData;
    }

    return (
      <Wrapper>
        {
          currentRound.results_viewable === false && Auth.getPosition() === "Student" ? (
            <Content>
              <RoundLockedScreen.Wrapper>
                <RoundLockedScreen.Image alt="Round results locked" src={IconLock} />
                <RoundLockedScreen.Title>Round Results Locked</RoundLockedScreen.Title>
                <RoundLockedScreen.Text>
                  The instructor has locked the results for this round. Check back when they reopen it.
                </RoundLockedScreen.Text>
              </RoundLockedScreen.Wrapper>
            </Content>
          ) : (
            <Fragment>
              <Navigation
                data={navigation}
                category={currentCategory}
                visitsHistory={visitsHistory}
                activeRound={activeRound}
                removeEngagement={true}
              />
              <Content>
                <ContentWrapper>
                  {Component && (
                    <Component
                      activeRound={activeRound}
                      rounds={rounds}
                      previousShownErrors={previousShownErrors}
                      reportsPerformanceFeedback={reportsPerformanceFeedback}
                      resultsTeamGrading={resultsTeamGrading}
                      resultsTargets={resultsTargets}
                      performanceFeedbackData={performanceFeedbackData}
                    />
                  )}
                </ContentWrapper>
                <Pagination
                  goNext={this.goNext}
                  goPrev={this.goPrev}
                  isFirstStep={this.isFirstStep}
                  isLastStep={this.isLastStep}
                  currentStep={currentStep + 1}
                  countOfSteps={this.countOfSteps}
                />
              </Content>
            </Fragment>
          )
        }
      </Wrapper>
    );
  }

}

export default PerformanceFeedback;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/index.js